import React from 'react';

const TableOfContents = ({ toc }) => {
    return (
        <div>
            <strong>V tem namigu najdeš: </strong>
            <ul className="space-y-2 mt-2 text-sm">
                {toc?.map((tocEntry, i) => {
                    return (
                        <li key={i}>
                            <a href={`#${tocEntry.id}`} className="hover:underline">
                                {tocEntry.text}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default TableOfContents;
